import axios from 'axios';
import { getInstance } from '../auth/authWrapper';

export async function listYEnterpriseSectorUsers() {
  const authService = getInstance();
  const token = await authService.waitForToken();
  return axios.get(`${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUsers`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function createYEnterpriseSectorUsers(data) {
  const authService = getInstance();
  const token = await authService.waitForToken();
  return axios.post(`${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUser`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function garnishYEnterpriseSectorUsers(data) {
  const authService = getInstance();
  const token = await authService.waitForToken();
  return axios.post(`${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUser/garnish`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function getYEnterpriseSectorUserSurveySession(yEnterpriseSectorUserId) {
  const authService = getInstance();
  const token = await authService.waitForToken();
  return axios.get(`${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUserSurveySession/${yEnterpriseSectorUserId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function getYEnterpriseSectorUserByNamespace(namespace, ethnosLogin, controlCode) {
  const authService = getInstance();
  const token = await authService.waitForToken();
  return axios.get(`${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUserByNamespace/${namespace}/${ethnosLogin}/${controlCode}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export default {};
